import React, { Component } from "react";
import emailjs from "@emailjs/browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faLocationDot,
    faEnvelope,
    faPhone,
} from "@fortawesome/free-solid-svg-icons";
import "./Contact.css";

class Contact extends Component {
    render() {
        const sendEmail = (e) => {
            e.preventDefault();
            emailjs
                .sendForm(
                    "service_40t8m6g",
                    "template_jbnpp8n",
                    e.target,
                    "IyqYqhIP4ieXtOw1u"
                )
                .then((result) => console.log(result))
                .catch((err) => console.log(err));
            e.target.reset();
        };
        return (
            <section id="contact" style={{ backgroundColor: "#151515" }}>
                <div className="container py-5">
                    <div className="row justify-content-center text-light">
                        <div className="col-md-8 col-8 text-center my-3">
                            <h5 className="text-uppercase fw-bold">contact</h5>
                            <h1 style={{ fontSize: "3.6rem" }}>
                                I'd Love To Hear From You.
                            </h1>
                            <p className="lead">
                                I hope you enjoyed exploring my projects and
                                learning more about my skills and experience as
                                a web developer. If you have any questions or
                                would like to discuss a potential project,
                                please don't hesitate to contact me.
                            </p>
                        </div>
                    </div>
                    <div className="row justify-content-center py-3">
                        <div className="col-md-10 col-10">
                            <form onSubmit={sendEmail}>
                                <div className="my-3">
                                    <input
                                        type="text"
                                        className="form-control form-field"
                                        name="name"
                                        placeholder="Name"
                                    />
                                </div>
                                <div className="my-3">
                                    <input
                                        type="email"
                                        className="form-control form-field"
                                        name="email"
                                        placeholder="Email"
                                    />
                                </div>
                                <div className="my-3">
                                    <input
                                        type="text"
                                        className="form-control form-field"
                                        name="subject"
                                        placeholder="Subject"
                                    />
                                </div>
                                <div className="my-3">
                                    <textarea
                                        className="form-control form-field"
                                        style={{
                                            minHeight: "10rem",
                                        }}
                                        name="message"
                                        placeholder="Message"
                                    />
                                </div>
                                <div className="my-3">
                                    <input
                                        style={{
                                            background: "#FF0077",
                                            border: "2px solid #FF0077",
                                            color: "#FFFFFF",
                                            height: "4rem",
                                            fontFamily: "'Poppins', sans-serif",
                                        }}
                                        type="submit"
                                        className="form-control rounded-0"
                                        value="SUBMIT"
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="row contact-info">
                        <div className="col-lg-4 col-12">
                            <div className="icon">
                                <FontAwesomeIcon
                                    style={{
                                        fontSize: "3.2rem",
                                        color: "#FFFFFF",
                                    }}
                                    icon={faLocationDot}
                                />
                            </div>

                            <h5>Where to find me</h5>

                            <p>
                                Dhanmondi - 15,
                                <br />
                                Dhaka,
                                <br />
                                Bangladesh.
                            </p>
                        </div>

                        <div className="col-lg-4 col-12">
                            <div className="icon">
                                <FontAwesomeIcon
                                    style={{
                                        fontSize: "3.2rem",
                                        color: "#FFFFFF",
                                    }}
                                    icon={faEnvelope}
                                />
                            </div>

                            <h5>Email Me At</h5>

                            <p>ferdous.hasan.cse@ulab.edu.bd</p>
                        </div>

                        <div className="col-lg-4 col-12">
                            <div className="icon">
                                <FontAwesomeIcon
                                    style={{
                                        fontSize: "3.2rem",
                                        color: "#FFFFFF",
                                    }}
                                    icon={faPhone}
                                />
                            </div>

                            <h5>Call Me At</h5>
                            <p>Mobile: 01678774794</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Contact;
